import { Layout, Menu, Dropdown, Avatar, Tag, Space } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  HomeOutlined,
  FileTextOutlined,
  TrophyOutlined,
  BookOutlined,
  FolderOpenOutlined,
  TeamOutlined,
  UserOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import { useAuthStore } from '../stores/auth';

const { Header, Sider, Content } = Layout;

const menuItems = [
  { key: '/', icon: <HomeOutlined />, label: '首页' },
  { key: '/contracts', icon: <FileTextOutlined />, label: '合同管理' },
  { key: '/biddings', icon: <TrophyOutlined />, label: '投标管理' },
  { key: '/experiences', icon: <BookOutlined />, label: '投标经验' },
  { key: '/templates', icon: <FolderOpenOutlined />, label: '制式文档' },
  { key: '/users', icon: <TeamOutlined />, label: '用户与权限' },
];

export default function AppLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuthStore();

  const envTag =
    (import.meta.env.VITE_APP_ENV as string | undefined) || 'dev';
  const isProd = envTag === 'production';

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider breakpoint="lg" collapsible>
        <div
          style={{
            color: '#fff',
            height: 56,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 16,
            fontWeight: 600,
            letterSpacing: 1,
          }}
        >
          DFRC 运营系统
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
        />
      </Sider>
      <Layout>
        <Header
          style={{
            background: '#fff',
            paddingInline: 24,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid #f0f0f0',
          }}
        >
          <Space>
            <span style={{ fontWeight: 600 }}>合同与投标管理</span>
            {!isProd && (
              <Tag color="orange">
                {envTag.toUpperCase()} · 测试环境，请勿录入真实数据
              </Tag>
            )}
          </Space>
          <Dropdown
            menu={{
              items: [
                {
                  key: 'logout',
                  icon: <LogoutOutlined />,
                  label: '退出登录',
                  onClick: () => {
                    logout();
                    navigate('/login');
                  },
                },
              ],
            }}
          >
            <Space style={{ cursor: 'pointer' }}>
              <Avatar icon={<UserOutlined />} />
              <span>{user?.name ?? user?.username}</span>
            </Space>
          </Dropdown>
        </Header>
        <Content style={{ margin: 24 }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
